'use strict';
/* COMPONENT - c.01.02 - navigation */

function checkboxHandler () {
    /* jshint validthis: true */
    if(this.checked) {
        this.parentElement.classList.add('checked');
    } else {
        this.parentElement.classList.remove('checked');
    }
}

function focusHandler () {
    /* jshint validthis: true */
    this.parentElement.classList.add('focused');
}

function blurHandler () {
    /* jshint validthis: true */
    this.parentElement.classList.remove('focused');
}

function radioHandler () {
    /* jshint validthis: true */
    let radios = document.querySelectorAll('[name="' + this.getAttribute('name') + '"]'),
        i;
    
    for (i = 0; i < radios.length; i += 1) {
        radios[i].parentElement.classList.remove('checked');
    }
    
    this.parentElement.classList.add('checked');
}

export default function () {
    let checkboxes = document.querySelectorAll('.checkbox input[type="checkbox"]'),
        radios = document.querySelectorAll('.radio input[type="radio"]'),
        datePickers = document.querySelectorAll('input.datepicker'),
        bs12 = document.querySelectorAll('.col-md-12'),
        bs4 = document.querySelectorAll('.col-md-4'),
        bsBtn = document.querySelectorAll('.btn'),
        i;
    
    if (document.body.clientWidth < 769) {
        for (i = 0; i < datePickers.length; i+= 1) {
            datePickers[i].type = 'date';
        }
    }
    
    if (!document.querySelector('.wffm-form fieldset')) {
        document.querySelector('.wffm-form').classList.add('noset');
    }
    
    for (i = 0; i < checkboxes.length; i+= 1) {
        checkboxes[i].addEventListener('click', checkboxHandler.bind(checkboxes[i]));
        checkboxes[i].addEventListener('focus', focusHandler.bind(checkboxes[i]));
        checkboxes[i].addEventListener('blur', blurHandler.bind(checkboxes[i]));
    }
    
    for (i = 0; i < radios.length; i+= 1) {
        radios[i].addEventListener('click', radioHandler.bind(radios[i]));
        radios[i].addEventListener('focus', focusHandler.bind(radios[i]));
        radios[i].addEventListener('blur', blurHandler.bind(radios[i]));
    }
    
    for (i = 0; i < bs12.length; i+= 1) {
        bs12[i].classList.add('base12');
    }
    
    for (i = 0; i < bs4.length; i+= 1) {
        bs4[i].classList.add('base4');
    }
    
    for (i = 0; i < bsBtn.length; i+= 1) {
        bsBtn[i].classList.add('cta');
    }
}